import { useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import {
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material';
// hooks
import useResponsive from '../../../../hooks/useResponsive';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const NORMAL_STEPS = ['1. 포지션', '2. 세부 포지션', '3. 예산', '4. 요청업무'];
const SHORT_STEPS = ['1. 포지션', '2. 예산', '3. 요청업무'];
const TECHLEAD_STEPS = ['1. 포지션', '2. 세부 포지션', '3. 예산'];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#000',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#000',
    zIndex: 1,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));


function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Iconify icon="ic:outline-check" width={22} height={22} className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}


export default function DirectStepper({ step, jobPost }) {
  const smUp = useResponsive('up', 'sm');
  const position = jobPost?.position;
  const noDetailPosition = ['product-manager', 'operator', 'finance'];

  const [techLeadSelected, setTechLeadSelected] = useState(jobPost?.detail_role?.role === "Tech Lead");
  const [aiPositionSelected, setAiPositionSelected] = useState(jobPost?.select_ai_position);
  const shortStep = noDetailPosition.includes(jobPost?.position) || aiPositionSelected;

  useEffect(() => {
    setTechLeadSelected(jobPost?.detail_role?.role === "Tech Lead");
    setAiPositionSelected(jobPost?.select_ai_position);
  }, [jobPost]);

  const steps = shortStep ? SHORT_STEPS : techLeadSelected ? TECHLEAD_STEPS : NORMAL_STEPS;
  const computedStep = shortStep ? step - 1 : step;

  return (
    <Stepper sx={{ width: '100%', maxWidth: smUp ? '500px' : '250px', py: smUp ? 1 : 0 }} alternativeLabel activeStep={computedStep || 0} connector={<QontoConnector />}>
      {steps.map((label) => {
        return (
        <Step key={label}>
          <StepLabel StepIconComponent={QontoStepIcon}>
            {smUp && (
            <Typography variant={smUp ? "body2" : "caption"}>{label}</Typography>
            )}
          </StepLabel>
        </Step>
      )}
      )}
    </Stepper>
  );
}
